import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useConfig } from "../../lib/config";
import { waLink } from "../../lib/api";

export function ProductCard({ product }) {
  const config = useConfig();
  const wa = waLink(
    config.whatsapp_number || "",
    `Hola, me interesa el producto ${product.name}. ¿Dónde puedo comprarlo?`
  );

  return (
    <div className="bg-white rounded-2xl border border-zinc-200 p-5 flex flex-col justify-between hover:border-brand-500 hover:shadow-lg hover:shadow-brand-500/10 transition-all duration-300 group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/productos/${product.slug}`} className="space-y-4" data-testid={`product-link-${product.slug}`}>
        <div className="aspect-square bg-zinc-50 rounded-xl flex items-center justify-center p-4 relative overflow-hidden">
          {product.image ? (
            <img src={product.image} alt={product.name} loading="lazy" className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500" />
          ) : (
            <span className="text-zinc-300 text-xs">Sin imagen</span>
          )}
          <span className="absolute top-3 left-3 bg-brand-600 text-white text-[10px] font-bold px-2 py-0.5 rounded">{product.category}</span>
        </div>
        <div>
          <span className="text-[11px] font-mono text-brand-700 uppercase tracking-wide">
            {product.line}{product.presentation ? ` · ${product.presentation}` : ""}
          </span>
          <h3 className="text-base font-bold text-zinc-950 mt-1 leading-snug">{product.name}</h3>
        </div>
      </Link>
      <div className="pt-4 mt-4 border-t border-zinc-100 flex items-center justify-between gap-2">
        <Link to={`/productos/${product.slug}`} className="text-xs font-medium text-zinc-400 hover:text-brand-700 transition-colors">
          Ver detalle
        </Link>
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-zinc-950 hover:bg-brand-600 text-white text-xs font-bold transition-colors"
          data-testid={`product-whatsapp-${product.slug}`}
        >
          <MessageCircle className="w-3.5 h-3.5" /> Consultar
        </a>
      </div>
    </div>
  );
}
